import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let HRPayed = new BaseTableModule('/ws/time_tracker_payed/');

const state = {
    ...HRPayed.state,
    columns: [
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, brief: false, width: 50},
        {text: 'Deleted', value: 'deleted', sortable: false, filterable: true, divider: true, brief: false, width: 50},
        {text: ' ', value: 'icon', sortable: false, filterable: true, divider: true, brief: true, width: 30},
        {text: 'Date', value: 'calendar_date_user__calendar_date__dt', sortable: true, filterable: true, divider: true, brief: true, width: 100},
        {text: 'User', value: 'calendar_date_user__human_user__user', sortable: true, filterable: true, divider: true, brief: false,},
        {text: 'Paid', value: 'paid', sortable: false, filterable: true, divider: true, brief: true, width: 100},
        {text: 'Extra hours', value: 'extra_hours', sortable: false, filterable: true, divider: true, brief: true, width: 100},
        {text: 'Comment', value: 'comment', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, brief: false,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['calendar_date_user__human_user__employee_number'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
};
const getters = {
    ...HRPayed.getters,
    getColumns(state) {
                if (state.briefView) {
                    return state.columns.filter(row => row.brief === true)
                } else {
                    return state.columns
                }
            },
};
const actions = {
    ...HRPayed.actions,
};
const mutations = {
    ...HRPayed.mutations,
};

export default {
    modules: {
        HRPayed: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}